import { CtaFooter } from './components/CtaFooter';
import { FeatureSection } from './components/FeatureSection';
import { HeroSection } from './components/HeroSection';
import { KeyNumbersSection } from './components/KeyNumbersSection';
import { Navbar } from './components/Navbar';
import { PremiumSection } from './components/PremiumSection';
import { SportsTabsSection } from './components/SportsTabsSection';
import { StatsSection } from './components/StatsSection';

function App() {
  return (
    <div className="min-h-screen bg-brand-deep text-white">
      <Navbar />
      <main>
        <HeroSection />
        <SportsTabsSection />
        <KeyNumbersSection />
        <FeatureSection />
        <StatsSection />
        <PremiumSection />
      </main>
      <CtaFooter />
    </div>
  );
}

export default App;
